import {
    Box,
    BoxProps,
    Button,
    ButtonProps,
    Grid,
    GridProps,
    useTheme,
} from "@mui/material";
import FileUpload, { FileUploadType } from "components/formsUI/FileUpload";
import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import * as Styles from "pages/requests/stepsIndividual/step2/step2.styles";
import { useField, useFormikContext } from "formik";
import { useParams } from "react-router-dom";

interface Props {
    title: string;
    onBackClick: () => void;
    showMessage: MessageBox;
}

export const INITIAL_FORM_STATE_STEP4: { fileUpload: FileUploadType[] } = {
    fileUpload: [],
};

const Content = (props: Props) => {
    const { title, onBackClick, showMessage } = props;
    const theme = useTheme();
    const { t } = useTranslation();
    const [filesUploaded, setFilesUploaded] = useState(false);
    const [fileUploadField] = useField("fileUpload");
    const { completionHash } = useParams();
    const { setFieldValue } = useFormikContext();

    useEffect(() => {
        console.log("Step4 file upload", fileUploadField.value.length);
        if (fileUploadField.value.length >= 1) {
            setFilesUploaded(true);
        }
    }, [setFilesUploaded]);

    // TODO : Move to Global Styles
    const gridContainerProps: GridProps = {
        container: true,
        spacing: 2,
        minHeight: { sm: 400, md: 450 },
    };

    const gridItemFullProps: GridProps = {
        item: true,
        xs: 12,
    };

    const titleProps: BoxProps = {
        component: "h1",
        sx: Styles.titleCSS(theme),
    };

    const buttonProps = (buttonName: string): ButtonProps => {
        if (buttonName === "previous") {
            return {
                onClick: onBackClick,
                variant: "contained",
                sx: Styles.buttonCSS(theme, buttonName),
            };
        } else {
            return {
                type: "submit",
                variant: "contained",
                sx: Styles.buttonCSS(theme, buttonName),
                disabled: !filesUploaded,
            };
        }
    };

    return (
        <Box sx={Styles.containerCSS(theme)}>
            <Grid {...gridContainerProps}>
                <Grid {...gridItemFullProps}>
                    <Box {...titleProps}>{title}</Box>
                    {/* <InfoMessage title={t(`requestIndividual.step4.warningTitle`)} text={t(`requestIndividual.step4.warning`)} icon={UploadIcon} isCollapsable={true} isCollapsed={true} /> */}
                    <Box sx={{ textAlign: "justify" }}>
                        {t(`requestIndividual.step4.warning`)}
                    </Box>
                    <FileUpload
                        showMessage={showMessage}
                        setFilesUploaded={setFilesUploaded}
                        fileUploads={fileUploadField.value}
                        completionHash={completionHash}
                        fileType={1}
                        getFiles={(files: FileUploadType[]) =>
                            setFieldValue("fileUpload", files)
                        }
                    />
                </Grid>
            </Grid>

            <Box sx={Styles.buttonContainerCSS(theme)}>
                <Button {...buttonProps("previous")}>
                    {t("buttons.previous")}
                </Button>
                <Button {...buttonProps("next")}>{t("buttons.next")}</Button>
            </Box>
        </Box>
    );
};

export default Content;
